jQuery(document).ready(function ($) {
  if (!$('body.product').length) {
    return;
  }

  console.log('Product Page JS');

  gsap.registerPlugin(ScrollTrigger);

  // Responsive
  // ---
  ScrollTrigger.matchMedia({
    // large
    '(max-width: 767px)': function () {
      // Image carousel on product page, mobile only
      // ---
      $('.variant-img-container .owl-carousel').each(function () {
        var $productslider = $(this);
        $productslider.owlCarousel({
          items: 1,
          singleItem: true,
          rewind: true,
          nav: false,
          dots: true,
          autoHeight: true,
          lazyLoad: true,
        });
      });
      // ---
      // END Image carousel on product page, mobile only
    },
    // all
    all: function () {
      // ScrollTriggers created here aren't associated with a particular media query,
      // so they persist.

      /*****************************************************************
       Jump to a different part of the page
      ******************************************************************/
      $('#ts').click(function (e) {
        e.preventDefault();
        $('html, body').animate(
          { scrollTop: $('#see-techspecs').offset().top },
          500
        );
      });
      /*****************************************************************
       END – Jump to a different part of the page
      ******************************************************************/
    },
  });
  // ---
  // END Responsive
});
